const children = [
    {
        id: 'clientSubscription',
        title: 'Subscription',
        type: 'collapse',
        url: '#',
        breadcrumbs: false,
        children: [
            {
                id: 'subscription',
                title: 'Subscription History',
                type: 'item',
                url: '/dashboard/client-subscription',
                breadcrumbs: false
            }
        ]
    }
];

const client_subscription = {
    id: 'clientSubscription',
    title: 'Subscription',
    type: 'group',
    children: children
};

export default client_subscription;
